import { render, staticRenderFns } from "./DesktopMenuItem.vue?vue&type=template&id=1ee9712b&"
import script from "./DesktopMenuItem.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default})
